import { plainToInstanceWithLVS } from '@goparrot/common';
import { GrammarNumberFormDto } from '../generated-dto';
export const DEFAULT_LOYALTY_POINTS_GRAMMAR_NUMBER_FORM = plainToInstanceWithLVS(GrammarNumberFormDto, {
    singular: 'point',
    plural: 'points',
}, { ignoreDecorators: true });
//# sourceMappingURL=dictionary.default-values.js.map